import { createContext } from 'react';

export const CodeLanguageContext = createContext<{
  language: number;
  labels: string[];
  titles: string[];
  setLanguage(index: number): void;
}>({ language: 0, labels: [], titles: [], setLanguage: () => null });
